import Error from './Error';

interface ErrorsProps {
	errors?: any[];
	margin?: boolean
}

const defaultProps = {
	errors: [],
	margin: true
}

function Errors(propsIn: ErrorsProps) {
	const props: any = {...defaultProps, ...propsIn};
	const style = {
		margin: '0 0 1em',
	};
	
	return (
		<div>
			{props.errors.length > 0 &&
				<div style={style}>
					{props.errors.map((error: any, index: number) =>
						<Error key={index} message={error.message} margin={props.margin} index={index} elementIdToLink={error.elementIdToLink} />
					)}
				</div>
			}
		</div>
	);
}

export default Errors;
